var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-action-bar"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('section',{staticClass:"c-action-bar__content"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }